import { render } from "./DrawingSettings.vue?vue&type=template&id=0cbb876c&scoped=true"
import script from "./DrawingSettings.vue?vue&type=script&lang=js"
export * from "./DrawingSettings.vue?vue&type=script&lang=js"

import "./DrawingSettings.vue?vue&type=style&index=0&id=0cbb876c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0cbb876c"

export default script